export const HALLOWEEN_2026_FULL_PRICE_PROMOTION_ID = 'HALLOWEEN50';
export const HALLOWEEN_2026_LOW_PRICE_PROMOTION_ID = 'HALLOWEEN10';

export type Halloween2026Variant = 'full' | 'low';

export function getHalloween2026Variant(promotionId: string | null | undefined): Halloween2026Variant | null {
  if (promotionId === HALLOWEEN_2026_FULL_PRICE_PROMOTION_ID) {
    return 'full';
  }
  if (promotionId === HALLOWEEN_2026_LOW_PRICE_PROMOTION_ID) {
    return 'low';
  }
  return null;
}

export function getHalloween2026SlideKey(variant: Halloween2026Variant): string {
  return `halloween-2026-${variant}`;
}

export function resolveHalloween2026Variant(
  forcedPromotionId: string | null | undefined,
  promotionId: string | null | undefined
): Halloween2026Variant | null {
  return getHalloween2026Variant(forcedPromotionId) ?? getHalloween2026Variant(promotionId);
}
